const reportWebVitals = (onPerfEntry) => {
  if (!(onPerfEntry && onPerfEntry instanceof Function)) return;

  import('web-vitals').then((vitals) => {
    // web-vitals v3+ uses on*; v2 used get*
    const onCLS = vitals.onCLS || ((cb) => vitals.getCLS && vitals.getCLS(cb));
    const onINP = vitals.onINP;
    const onFID = vitals.onFID || ((cb) => vitals.getFID && vitals.getFID(cb));
    const onFCP = vitals.onFCP || ((cb) => vitals.getFCP && vitals.getFCP(cb));
    const onLCP = vitals.onLCP || ((cb) => vitals.getLCP && vitals.getLCP(cb));
    const onTTFB = vitals.onTTFB || ((cb) => vitals.getTTFB && vitals.getTTFB(cb));

    if (onCLS) onCLS(onPerfEntry);
    if (onINP) onINP(onPerfEntry);
    else if (onFID) onFID(onPerfEntry);
    if (onFCP) onFCP(onPerfEntry);
    if (onLCP) onLCP(onPerfEntry);
    if (onTTFB) onTTFB(onPerfEntry);
  });
};

export default reportWebVitals;
